<template>
  <div>
    <Teleport to="body">
      <TextUsModal v-if="showTextUsModal" @hidemodal="showTextUsModal = false" />
      <GetOfferFormModal v-if="showGetOfferForm" @hideModal="showGetOfferForm = false" />
      <RequestQuoteModal v-if="showRequestQuoteModal" />
      <DirectionsModal v-if="showMapDirectionsModal" />
      <RegistrationModal v-if="showRegistrationModal" />
      <TestDriveModal v-if="showTestDriveModal" />
      <ScheduleServiceModal v-if="showScheduleServiceModal" />
      <ContactFinanceDealerModal v-if="showContactFinanceDealerModal" />
      <BonusOfferModal v-if="showBonusOfferModal" />
      <GetFinanceModal v-if="showGetFinanceModal" />
      <CookieDisclaimer v-if="showCookieDisclaimer" />
      <ValueYourTradeModal v-if="showValueYourTradeModal" />
      <Loader v-if="showLoading" />
      <SignInModal v-if="showSignInModal" />
      <TextPermissionOverlay v-if="showTextPermissionOverlay" />
      <DisasterBanner v-if="enableDisasterBanner" />
      <TextModal v-if="showTextModal" />
      <ServiceAppraisalPopup
        v-if="showServiceAppraisalPopup"
        @hideModal="showServiceAppraisalPopup = false"
      />
      <PrecisionBonusOfferPopup
        v-if="showPrecissionBonusOfferPopup"
        @hideModal="showPrecissionBonusOfferPopup = false"
      />
      <PrecisionTradeValuePopup
        v-if="showPrecisionTradeValuePopup"
        @hideModal="showPrecisionTradeValuePopup = false"
      />
      <IframeModal v-if="showIframeModal && iframeUrl" />
      <PrivacyStatement v-if="showPrivacyPolicyModal" />
      <ContactServiceModal v-if="showContactServiceModal" />
      <ContactGeneralAdminModal v-if="showContactGeneralAdminModal" />
      <ContactPartsModal v-if="showContactPartsModal" />
      <ContactUsModal v-if="showContactUsModal" />
      <TermsOfUse v-if="showTermsOfUseModal" />
      <PartsAccessoriesModal v-if="showAccessoryModal" />
      <CallButtons v-if="showCallUsButtonsModal" />
      <BuyNowPopup v-if="showBuyNowPopUp" />
      <SelectLocationModal
        v-if="showLocationModal"
        :modaltype="locationModalPageName"
        @hideModal="showLocationModal = false"
      />
      <CommonIframeModal v-if="iframeModalPopUpDetails" />
      <GoogleAssistant v-if="showGoogleAssistantModal" />
      <AdditionalDisclosureModal
        v-if="showAdditionalDisclosureModal"
        @hideModal="showAdditionalDisclosureModal = false"
      />
      <SchedulePickupPopup v-if="showSchedulePickupModal" />
      <OtpDetailsModal
        v-if="openOtpDetailsModal"
        :otpModalData="otpModalData"
        @otp-close-event="handleOtpClose"
      />
    </Teleport>
    <ScheduleServiceButton v-if="enableScheduleServiceButton" />
    <SearchMenuContainer v-if="showSearchMenu" />
    <SignInBackModal v-if="showSignOutModal" />
    <Teleport to="._website_header">
      <HoverSignInPopup v-if="enableHoverSignInPopup" />
    </Teleport>
  </div>
</template>

<script setup>
import { defineAsyncComponent } from "vue";
const TextUsModal = defineAsyncComponent(() =>
  import("@vue3/src/Components/Shared/TextUs/TextUs.vue")
);
const RequestQuoteModal = defineAsyncComponent(() =>
  import("@vue3/src/Components/LeadForms/RequestQuote/RequestQuoteModal.vue")
);

const ValueYourTradeModal = defineAsyncComponent(() =>
  import("../LeadForms/ValueYourTrade/ValueYourTradeModal/ValueYourTradeModal.vue")
);
const GetOfferFormModal = defineAsyncComponent(() =>
  import("../LeadForms/GetOfferForm/GetOfferFormModal/GetOfferFormModal.vue")
);

const RegistrationModal = defineAsyncComponent(() =>
  import("../Modals/RegistrationModal/RegistrationModal.vue")
);
const Loader = defineAsyncComponent(() => import("@vue3/src/Components/Shared/Loader/Loader.vue"));
import { useLeadFormsStore } from "@vue3/src/store/LeadForms/LeadFormsStore";
import { storeToRefs } from "pinia";
import { useLoaderStore } from "@vue3/src/store/Shared/Loader/LoaderStore";
const DirectionsModal = defineAsyncComponent(() =>
  import("@vue3/src/Components/Modals/DirectionsModal/DirectionsModal.vue")
);

import { useMapDirectionsStore } from "../../store/MapDirections/MapDirectionsStore";
import { useRegistrationStore } from "../../store/Registration/RegistrationStore";
const CookieDisclaimer = defineAsyncComponent(() =>
  import("../../Components/CookieDisclaimer/CookieDisclaimer.vue")
);
const SignInModal = defineAsyncComponent(() =>
  import("../../Components/Modals/SignInModal/SignInModal.vue")
);
const TextPermissionOverlay = defineAsyncComponent(() =>
  import("../../Components/TextPermissionsOverlay/TextPermissionsOverlay.vue")
);
const DisasterBanner = defineAsyncComponent(() =>
  import("../../../../js/components/disasterBanner/disasterBanner.vue")
);
const TestDriveModal = defineAsyncComponent(() =>
  import("../../Components/LeadForms/TestDrive/TestDriveModal/TestDriveModal.vue")
);
const ScheduleServiceModal = defineAsyncComponent(() =>
  import("../../Components/LeadForms/ScheduleService/ScheduleServiceModal/ScheduleServiceModal.vue")
);
const PrecisionBonusOfferPopup = defineAsyncComponent(() =>
  import("../PrecisionBonusOfferPopup/PrecisionBonusOfferPopup.vue")
);
const ServiceAppraisalPopup = defineAsyncComponent(() =>
  import("../ServiceAppraisalPopup/ServiceAppraisalPopup.vue")
);
const GetFinanceModal = defineAsyncComponent(() =>
  import("../LeadForms/GetFinance/GetFinanceModal/GetFinanceModal.vue")
);
const BonusOfferModal = defineAsyncComponent(() =>
  import("../LeadForms/BonusOffer/BonusOfferModal/BonusOfferModal.vue")
);
const TextModal = defineAsyncComponent(() =>
  import("../../Components/Shared/TextModal/TextModal.vue")
);
import { useTextModalStore } from "../../store/Shared/TextModalStore/TextModalStore";
const PrecisionTradeValuePopup = defineAsyncComponent(() =>
  import("../PrecisionTradeValuePopup/PrecisionTradeValuePopup.vue")
);
const IframeModal = defineAsyncComponent(() =>
  import("../../Components/Modals/IframeModal/IframeModal.vue")
);
import { useIframeModalStore } from "../../store/IframeModalStore/IframeModalStore";
const HoverSignInPopup = defineAsyncComponent(() =>
  import("../../Components/HoverSignInPopup/HoverSignInPopup.vue")
);
const PrivacyStatement = defineAsyncComponent(() =>
  import("../Modals/PrivacyStatement/PrivacyStatement.vue")
);
import { useFooterStore } from "../../store/Shared/FooterStore/footerStore";
const SearchMenuContainer = defineAsyncComponent(() =>
  import("../../Components/SearchMenu/SearchMenuContainer/SearchMenuContainer.vue")
);
const ContactServiceModal = defineAsyncComponent(() =>
  import("../../Components/LeadForms/ContactService/ContactServiceModal/ContactServiceModal.vue")
);
const ContactFinanceDealerModal = defineAsyncComponent(() =>
  import(
    "@vue3/src/Components/LeadForms/ContactFinanceDealer/ContactFinanceDealerModal/ContactFinanceDealerModal.vue"
  )
);
import { useSearchMenuStore } from "../../store/Shared/SearchMenuStore/SearchMenuStore";

const ContactGeneralAdminModal = defineAsyncComponent(() =>
  import(
    "../../Components/LeadForms/ContactGeneralAdmin/ContactGeneralAdminModal/ContactGeneralAdminModal.vue"
  )
);
const ContactPartsModal = defineAsyncComponent(() =>
  import("../../Components/LeadForms/ContactParts/ContactPartsModal/ContactPartsModal.vue")
);
const ContactUsModal = defineAsyncComponent(() =>
  import("../../Components/LeadForms/ContactUs/ContactUsModal/ContactUsModal.vue")
);
const TermsOfUse = defineAsyncComponent(() => import("../Modals/TermsOfUse/TermsOfUse.vue"));
const PartsAccessoriesModal = defineAsyncComponent(() =>
  import(
    "../../Components/LeadForms/PartsAccessories/PartsAccessoriesModal/PartsAccessoriesModal.vue"
  )
);
const CallButtons = defineAsyncComponent(() =>
  import("../../Components/CallButtons/CallButtons.vue")
);
const ScheduleServiceButton = defineAsyncComponent(() =>
  import("@/js/components/shared/ScheduleServiceButton/ScheduleServiceButton.vue")
);
const SignInBackModal = defineAsyncComponent(() =>
  import("../Modals/SignInModal/SignInBackModal.vue")
);
const BuyNowPopup = defineAsyncComponent(() =>
  import("../../Components/BuyParagonHonda/BuyParagonHonda.vue")
);
import { useBuyNowModalStore } from "../../store/Shared/BuyNowModalStore/BuyNowModalStore";

import { useDisasterStore } from "../../store/DisasterStore/DisasterStore";
import { useScheduleServiceStore } from "../../store/ScheduleServiceStore/ScheduleServiceStore";
const CommonIframeModal = defineAsyncComponent(() =>
  import("../CommonIframeModal/CommonIframeModal.vue")
);
const AdditionalDisclosureModal = defineAsyncComponent(() =>
  import("../Modals/AdditionalDisclosureModal/AdditionalDisclosureModal.vue")
);
const SelectLocationModal = defineAsyncComponent(() =>
  import("../Modals/SelectLocationModal/SelectLocationModal.vue")
);
const GoogleAssistant = defineAsyncComponent(() =>
  import("../../Components/GoogleAssistant/GoogleAssistant.vue")
);
const SchedulePickupPopup = defineAsyncComponent(() =>
  import("../SchedulePickupPopup/SchedulePickupPopup.vue")
);
const OtpDetailsModal = defineAsyncComponent(() =>
  import("../../../../js/WebsitePrimary/components/OtpDetailsModal/OtpDetailsModal.vue")
);
//Pinia Store Variables
const {
  showRequestQuoteModal,
  showGetOfferForm,
  showValueYourTradeModal,
  showTestDriveModal,
  showScheduleServiceModal,
  showBonusOfferModal,
  showGetFinanceModal,
  showContactServiceModal,
  showAccessoryModal,
  showPrecisionTradeValuePopup,
  showServiceAppraisalPopup,
  showPrecissionBonusOfferPopup,
  showCallUsButtonsModal,
  showTextPermissionOverlay,
  leadFormFormProps,
  showContactGeneralAdminModal,
  showContactPartsModal,
  showContactFinanceDealerModal,
  showContactUsModal,
  showGoogleAssistantModal,
  showSchedulePickupModal,
  openOtpDetailsModal,
  otpModalData,
  showTextUsModal,
} = storeToRefs(useLeadFormsStore());

const { showLoading } = storeToRefs(useLoaderStore());
const { showTextModal, showCookieDisclaimer } = storeToRefs(useTextModalStore());
const { showMapDirectionsModal } = storeToRefs(useMapDirectionsStore());
const {
  showRegistrationModal,
  showSignInModal,
  showSignOutModal,
  showLocationModal,
  locationModalPageName,
  enableHoverSignInPopup,
} = storeToRefs(useRegistrationStore());
const { showBuyNowPopUp } = storeToRefs(useBuyNowModalStore());
const { showIframeModal, iframeUrl, iframeModalPopUpDetails } = storeToRefs(useIframeModalStore());
const { showPrivacyPolicyModal, showTermsOfUseModal, showAdditionalDisclosureModal } = storeToRefs(
  useFooterStore()
);
const { showSearchMenu } = storeToRefs(useSearchMenuStore());
const { enableDisasterBanner } = storeToRefs(useDisasterStore());
const { enableScheduleServiceButton } = storeToRefs(useScheduleServiceStore());

function handleOtpClose() {
  openOtpDetailsModal.value = false;
}
</script>
